export default function Zones() {
  const zones = [
    {
      name: 'Une zone du visage',
      price: '399€',
      duration: '60 min',
      description: 'Transformation naturelle',
      popular: true
    },
    {
      name: 'Yeux complet (4zones)',
      price: '279€',
      duration: '30 min',
      description: 'Cible les rides et poches'
    },
    {
      name: 'Mains',
      price: '99€',
      duration: '10 min',
      description: 'Amélioration de la zone'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-4">
              Nos <span className="font-semibold text-rose-500">soins</span>
            </h2>
            <p className="text-lg text-gray-600">
              Choisissez la zone à traiter
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {zones.map((zone, index) => (
              <div 
                key={index} 
                className={`relative bg-white rounded-2xl p-6 border-2 hover:shadow-xl transition-all duration-300 ${
                  zone.popular ? 'border-rose-500' : 'border-rose-100 hover:border-rose-300'
                }`}
              >
                {zone.popular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-rose-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                    Le plus populaire
                  </div>
                )}
                
                <div className="text-center">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{zone.name}</h3>
                  <p className="text-sm text-gray-600 mb-4">{zone.description}</p>
                  
                  <div className="mb-4">
                    <div className="text-3xl font-bold text-rose-500">{zone.price}</div>
                    <div className="text-sm text-gray-500">{zone.duration}</div>
                  </div>

                  <button className="w-full px-4 py-3 bg-rose-500 text-white rounded-lg font-medium hover:bg-rose-600 transition-all cursor-pointer whitespace-nowrap">
                    Réserver
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 space-y-6">
            <div className="text-center">
              <p className="text-gray-600 flex items-center justify-center gap-2">
                <i className="ri-information-line text-rose-500"></i>
                Tous nos tarifs incluent une consultation préalable et des conseils post-soin
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
              <div className="bg-gradient-to-br from-rose-50 to-white p-6 rounded-xl border border-rose-200">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                    <i className="ri-calendar-check-line text-rose-500"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Séances recommandées</h4>
                    <p className="text-sm text-gray-600">1 à 3 séances pour des résultats optimaux</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-rose-50 to-white p-6 rounded-xl border border-rose-200">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                    <i className="ri-shield-check-line text-rose-500"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Résultats durables</h4>
                    <p className="text-sm text-gray-600">Aucune retouche à prévoir pendant 3 ans</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}